import { render, staticRenderFns } from "./ReviewGala.vue?vue&type=template&id=3acc3c94&scoped=true"
import script from "./ReviewGala.vue?vue&type=script&lang=js"
export * from "./ReviewGala.vue?vue&type=script&lang=js"
import style0 from "./ReviewGala.vue?vue&type=style&index=0&id=3acc3c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc3c94",
  null
  
)

export default component.exports